export default __webpack_public_path__ + "static/media/calendar.63e9d2ac.svg";